
var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define('core/file_system',["require", "exports", './api_error', './file_flag', './node_path', './buffer'], function(require, exports, api_error, file_flag, node_path, buffer) {
    var ApiError = api_error.ApiError;
    var ErrorCode = api_error.ErrorCode;
    var path = node_path.path;
    var Buffer = buffer.Buffer;

    

    

    var BaseFileSystem = (function () {
        function BaseFileSystem() {
        }
        BaseFileSystem.prototype.supportsLinks = function () {
            return false;
        };
        BaseFileSystem.prototype.diskSpace = function (p, cb) {
            cb(0, 0);
        };
        BaseFileSystem.prototype.open = function (p, flag, mode, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFileSystem.prototype.rename = function (oldPath, newPath, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFileSystem.prototype.renameSync = function (oldPath, newPath) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFileSystem.prototype.stat = function (p, isLstat, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFileSystem.prototype.statSync = function (p, isLstat) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFileSystem.prototype.openSync = function (p, flag, mode) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFileSystem.prototype.unlink = function (p, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFileSystem.prototype.unlinkSync = function (p) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFileSystem.prototype.rmdir = function (p, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFileSystem.prototype.rmdirSync = function (p) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFileSystem.prototype.mkdir = function (p, mode, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFileSystem.prototype.mkdirSync = function (p, mode) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFileSystem.prototype.readdir = function (p, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFileSystem.prototype.readdirSync = function (p) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFileSystem.prototype.exists = function (p, cb) {
            this.stat(p, null, function (err) {
                cb(err == null);
            });
        };
        BaseFileSystem.prototype.existsSync = function (p) {
            try  {
                this.statSync(p, true);
                return true;
            } catch (e) {
                return false;
            }
        };
        BaseFileSystem.prototype.realpath = function (p, cache, cb) {
            if (this.supportsLinks()) {
                var splitPath = p.split(path.sep);

                for (var i = 0; i < splitPath.length; i++) {
                    var addPaths = splitPath.slice(0, i + 1);
                    splitPath[i] = path.join.apply(null, addPaths);
                }
            } else {
                this.exists(p, function (doesExist) {
                    if (doesExist) {
                        cb(null, p);
                    } else {
                        cb(new ApiError(1 /* ENOENT */, "File " + p + " not found."));
                    }
                });
            }
        };
        BaseFileSystem.prototype.realpathSync = function (p, cache) {
            if (this.supportsLinks()) {
                var splitPath = p.split(path.sep);

                for (var i = 0; i < splitPath.length; i++) {
                    var addPaths = splitPath.slice(0, i + 1);
                    splitPath[i] = path.join.apply(null, addPaths);
                }
            } else {
                if (this.existsSync(p)) {
                    return p;
                } else {
                    throw new ApiError(1 /* ENOENT */, "File " + p + " not found.");
                }
            }
        };
        BaseFileSystem.prototype.truncate = function (p, len, cb) {
            this.open(p, file_flag.FileFlag.getFileFlag('w'), 0x1a4, (function (er, fd) {
                if (er) {
                    return cb(er);
                }
                fd.truncate(len, (function (er) {
                    fd.close((function (er2) {
                        cb(er || er2);
                    }));
                }));
            }));
        };
        BaseFileSystem.prototype.truncateSync = function (p, len) {
            var fd = this.openSync(p, file_flag.FileFlag.getFileFlag('w'), 0x1a4);

            try  {
                fd.truncateSync(len);
            } catch (e) {
                throw e;
            } finally {
                fd.closeSync();
            }
        };
        BaseFileSystem.prototype.readFile = function (fname, encoding, flag, cb) {
            var oldCb = cb;

            this.open(fname, flag, 0x1a4, function (err, fd) {
                if (err) {
                    return cb(err);
                }
                cb = function (err, arg) {
                    fd.close(function (err2) {
                        if (err == null) {
                            err = err2;
                        }
                        return oldCb(err, arg);
                    });
                };
                fd.stat(function (err, stat) {
                    if (err != null) {
                        return cb(err);
                    }

                    var buf = new Buffer(stat.size);
                    fd.read(buf, 0, stat.size, 0, function (err) {
                        if (err != null) {
                            return cb(err);
                        } else if (encoding === null) {
                            return cb(err, buf);
                        }
                        try  {
                            cb(null, buf.toString(encoding));
                        } catch (e) {
                            cb(e);
                        }
                    });
                });
            });
        };
        BaseFileSystem.prototype.readFileSync = function (fname, encoding, flag) {
            var fd = this.openSync(fname, flag, 0x1a4);
            try  {
                var stat = fd.statSync();

                var buf = new Buffer(stat.size);
                fd.readSync(buf, 0, stat.size, 0);
                fd.closeSync();
                if (encoding === null) {
                    return buf;
                }
                return buf.toString(encoding);
            } finally {
                fd.closeSync();
            }
        };
        BaseFileSystem.prototype.writeFile = function (fname, data, encoding, flag, mode, cb) {
            var oldCb = cb;

            this.open(fname, flag, 0x1a4, function (err, fd) {
                if (err != null) {
                    return cb(err);
                }
                cb = function (err) {
                    fd.close(function (err2) {
                        oldCb(err != null ? err : err2);
                    });
                };

                try  {
                    if (typeof data === 'string') {
                        data = new Buffer(data, encoding);
                    }
                } catch (e) {
                    return cb(e);
                }

                fd.write(data, 0, data.length, 0, cb);
            });
        };
        BaseFileSystem.prototype.writeFileSync = function (fname, data, encoding, flag, mode) {
            var fd = this.openSync(fname, flag, mode);
            try  {
                if (typeof data === 'string') {
                    data = new Buffer(data, encoding);
                }

                fd.writeSync(data, 0, data.length, 0);
            } finally {
                fd.closeSync();
            }
        };
        BaseFileSystem.prototype.appendFile = function (fname, data, encoding, flag, mode, cb) {
            var oldCb = cb;
            this.open(fname, flag, mode, function (err, fd) {
                if (err != null) {
                    return cb(err);
                }
                cb = function (err) {
                    fd.close(function (err2) {
                        oldCb(err != null ? err : err2);
                    });
                };
                if (typeof data === 'string') {
                    data = new Buffer(data, encoding);
                }
                fd.write(data, 0, data.length, null, cb);
            });
        };
        BaseFileSystem.prototype.appendFileSync = function (fname, data, encoding, flag, mode) {
            var fd = this.openSync(fname, flag, mode);
            try  {
                if (typeof data === 'string') {
                    data = new Buffer(data, encoding);
                }
                fd.writeSync(data, 0, data.length, null);
            } finally {
                fd.closeSync();
            }
        };
        BaseFileSystem.prototype.chmod = function (p, isLchmod, mode, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFileSystem.prototype.chmodSync = function (p, isLchmod, mode) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFileSystem.prototype.chown = function (p, isLchown, uid, gid, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFileSystem.prototype.chownSync = function (p, isLchown, uid, gid) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFileSystem.prototype.utimes = function (p, atime, mtime, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFileSystem.prototype.utimesSync = function (p, atime, mtime) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFileSystem.prototype.link = function (srcpath, dstpath, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFileSystem.prototype.linkSync = function (srcpath, dstpath) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFileSystem.prototype.symlink = function (srcpath, dstpath, type, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFileSystem.prototype.symlinkSync = function (srcpath, dstpath, type) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFileSystem.prototype.readlink = function (p, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFileSystem.prototype.readlinkSync = function (p) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        return BaseFileSystem;
    })();
    exports.BaseFileSystem = BaseFileSystem;

    var SynchronousFileSystem = (function (_super) {
        __extends(SynchronousFileSystem, _super);
        function SynchronousFileSystem() {
            _super.apply(this, arguments);
        }
        SynchronousFileSystem.prototype.supportsSynch = function () {
            return true;
        };

        SynchronousFileSystem.prototype.rename = function (oldPath, newPath, cb) {
            try  {
                this.renameSync(oldPath, newPath);
                cb();
            } catch (e) {
                cb(e);
            }
        };

        SynchronousFileSystem.prototype.stat = function (p, isLstat, cb) {
            try  {
                cb(null, this.statSync(p, isLstat));
            } catch (e) {
                cb(e);
            }
        };

        SynchronousFileSystem.prototype.open = function (p, flags, mode, cb) {
            try  {
                cb(null, this.openSync(p, flags, mode));
            } catch (e) {
                cb(e);
            }
        };

        SynchronousFileSystem.prototype.unlink = function (p, cb) {
            try  {
                this.unlinkSync(p);
                cb();
            } catch (e) {
                cb(e);
            }
        };

        SynchronousFileSystem.prototype.rmdir = function (p, cb) {
            try  {
                this.rmdirSync(p);
                cb();
            } catch (e) {
                cb(e);
            }
        };

        SynchronousFileSystem.prototype.mkdir = function (p, mode, cb) {
            try  {
                this.mkdirSync(p, mode);
                cb();
            } catch (e) {
                cb(e);
            }
        };

        SynchronousFileSystem.prototype.readdir = function (p, cb) {
            try  {
                cb(null, this.readdirSync(p));
            } catch (e) {
                cb(e);
            }
        };

        SynchronousFileSystem.prototype.chmod = function (p, isLchmod, mode, cb) {
            try  {
                this.chmodSync(p, isLchmod, mode);
                cb();
            } catch (e) {
                cb(e);
            }
        };

        SynchronousFileSystem.prototype.chown = function (p, isLchown, uid, gid, cb) {
            try  {
                this.chownSync(p, isLchown, uid, gid);
                cb();
            } catch (e) {
                cb(e);
            }
        };

        SynchronousFileSystem.prototype.utimes = function (p, atime, mtime, cb) {
            try  {
                this.utimesSync(p, atime, mtime);
                cb();
            } catch (e) {
                cb(e);
            }
        };

        SynchronousFileSystem.prototype.link = function (srcpath, dstpath, cb) {
            try  {
                this.linkSync(srcpath, dstpath);
                cb();
            } catch (e) {
                cb(e);
            }
        };

        SynchronousFileSystem.prototype.symlink = function (srcpath, dstpath, type, cb) {
            try  {
                this.symlinkSync(srcpath, dstpath, type);
                cb();
            } catch (e) {
                cb(e);
            }
        };

        SynchronousFileSystem.prototype.readlink = function (p, cb) {
            try  {
                cb(null, this.readlinkSync(p));
            } catch (e) {
                cb(e);
            }
        };
        return SynchronousFileSystem;
    })(BaseFileSystem);
    exports.SynchronousFileSystem = SynchronousFileSystem;
});
//# sourceMappingURL=file_system.js.map
;